export default {
  nav_brand: 'AllChinaBuy Spreadsheet',
  nav_home: 'Forside',
  nav_categories: 'Kategorier',
  nav_guides: 'Indkøbsguide',
  nav_faq: 'FAQ',
  lang_switch: 'Sprog',
  lang_en: 'English',
  lang_fr: 'Français',
  lang_de: 'Deutsch',
  lang_da: 'Dansk',

  hero_h1: 'AllChinaBuy Spreadsheet — Find Produkter, Sælgere & Købsguides',
  hero_subtitle: 'Opdag de seneste AllChinaBuy ressourcer, populære produkter, pålidelige sælgeroplysninger, QC-tips, forsendelsesguides og praktiske købsråd — alt på ét sted.',
  hero_cta_primary: 'Udforsk AllChinaBuy Spreadsheet',
  hero_cta_secondary: 'Gennemse Populære Fund',
  hero_trust: 'Opdaterede ressourcer • Uafhængige informationer • Begyndervenlige guides',
  hero_support_title: 'Leder du efter et AllChinaBuy Spreadsheet?',
  hero_support_desc: 'Find nyttige produktlister, sælgerressourcer, kategorivejledninger, QC-oplysninger, forsendelsesråd og AllChinaBuy-købstips uden at søge på snesevis af websites.',

  whatis_title: 'Hvad er AllChinaBuy Spreadsheet?',
  whatis_desc: 'Et AllChinaBuy Spreadsheet er en kurateret samling af produktlinks, sælgeroplysninger, købsguides og kvalitetskontroltips, der er samlet for at hjælpe købere med at finde de bedste varer gennem AllChinaBuy-købsagentplatformen.',
  step_find: 'Find',
  step_find_desc: 'Gennemse kuraterede produktlister og sælgerkataloger organiseret efter kategori.',
  step_research: 'Research',
  step_research_desc: 'Sammenlign sælgere, tjek QC-fotos, og gennemgå forsendelsesmuligheder før køb.',
  step_buy: 'Køb',
  step_buy_desc: 'Bestil trygt med verificerede ressourcer og praktiske købsguides.',

  categories_title: 'Populære Spreadsheet Kategorier',
  categories_subtitle: 'Udforsk organiserede produktkategorier for at finde præcis det, du har brug for gennem AllChinaBuy.',
  cat_shoes: 'Sko',
  cat_hoodies: 'Hættetrøjer / Sweaters',
  cat_tshirts: 'T-Shirts',
  cat_jackets: 'Jakker',
  cat_pants: 'Bukser / Shorts',
  cat_headwear: 'Hovedbeklædning',
  cat_sets: 'Sæt',
  cat_underwear: 'Undertøj',
  cat_jersey: 'Trøjer',
  cat_accessories: 'Tilbehør',
  cat_bags: 'Tasker',
  cat_belts: 'Bælter',
  cat_perfumes: 'Parfumer',
  cat_other: 'Andet',
  cat_fashion: 'Mode',
  cat_streetwear: 'Streetwear',
  cat_sportswear: 'Sportstøj',
  cat_electronics: 'Elektronik',
  cat_home: 'Hjem & Livsstil',
  cat_popular: 'Populære Fund',

  featured_title: 'Udvalgte AllChinaBuy Spreadsheet Ressourcer',
  featured_subtitle: 'Et kurateret overblik af produkter, sælgere og guides til at navigere AllChinaBuy effektivt.',
  col_product: 'Produkt',
  col_category: 'Kategori',
  col_seller: 'Sælger',
  col_qc: 'QC',
  col_guide: 'Guide',
  col_action: 'Handling',
  action_view: 'Se Detaljer',

  guides_title: 'Populære AllChinaBuy Guides',
  guide_spreadsheet: 'AllChinaBuy Spreadsheet Guide',
  guide_review: 'AllChinaBuy Anmeldelse',
  guide_shipping: 'AllChinaBuy Forsendelsesomkostninger',
  guide_coupon: 'AllChinaBuy Kupon',
  guide_discount: 'AllChinaBuy Rabatkode',
  guide_warehouse: 'AllChinaBuy Lager',
  guide_legit: 'Er AllChinaBuy Legitim?',
  guide_qc: 'AllChinaBuy QC Guide',
  guide_order: 'Sådan Bestiller Du Fra AllChinaBuy',
  guide_buying: 'AllChinaBuy Købsguide',
  guide_read: 'Læs Guide',

  why_title: 'Hvorfor Bruge Denne Ressource?',
  why_organized_title: 'Organiserede Ressourcer',
  why_organized_desc: 'Find nyttige AllChinaBuy-oplysninger på ét sted.',
  why_buying_title: 'Købsguides',
  why_buying_desc: 'Forstå produkter, sælgere, QC, forsendelse og bestilling.',
  why_compare_title: 'Sammenligningsresearch',
  why_compare_desc: 'Sammenlign AllChinaBuy med andre købsagentplatforme.',
  why_safety_title: 'Sikkerhedsinformation',
  why_safety_desc: 'Lær at identificere risici og træffe velinformerede beslutninger.',

  compare_title: 'AllChinaBuy vs Andre Købsagenter',
  compare_subtitle: 'Sammenlign vigtige funktioner og forskelle mellem AllChinaBuy og andre populære købsagentplatforme.',
  compare_feature: 'Funktion',
  compare_allchinabuy: 'AllChinaBuy',
  compare_superbuy: 'Superbuy',
  compare_cssbuy: 'CSSBuy',
  compare_sugargoo: 'Sugargoo',
  compare_pandabuy: 'PandaBuy',
  compare_check: 'Tjek aktuel tilgængelighed',

  safety_title: 'Køb Klogere med AllChinaBuy Sikkerhedsguides',
  safety_desc: 'Før du afgiver nogen bestilling, lær vigtige sikkerhedsprocedurer, der beskytter dine penge, dine data og din shoppingoplevelse.',
  safety_seller_title: 'Sælgerresearch',
  safety_seller_desc: 'Lær at verificere sælgere, før du forpligter dig til et køb.',
  safety_qc_title: 'QC Fotos',
  safety_qc_desc: 'Forstå hvorfor kvalitetskontrolfotos er vigtige, og hvordan du anmoder om dem.',
  safety_link_title: 'Mistænkelige Links',
  safety_link_desc: 'Identificer advarselstegn i produktlister og sælgersider.',
  safety_payment_title: 'Betalingssikkerhed',
  safety_payment_desc: 'Brug sikre betalingsmetoder og forstå køberbeskyttelser.',
  safety_shipping_title: 'Forsendelsesrisici',
  safety_shipping_desc: 'Navigér gennem told, forsikring og leveringsovervejelser.',
  safety_refund_title: 'Refunderingsovervejelser',
  safety_refund_desc: 'Kend dine rettigheder og platformpolitikker, før du køber.',

  faq_title: 'Ofte Stillede Spørgsmål',
  faq_q1: 'Hvad er et AllChinaBuy Spreadsheet?',
  faq_a1: 'Et AllChinaBuy Spreadsheet er en kurateret samling af produktlinks, sælgerreferencer, købsguides og tips, organiseret for at hjælpe købere med effektivt at navigere på AllChinaBuy-platformen.',
  faq_q2: 'Er AllChinaBuy en legitim købsagent?',
  faq_a2: 'AllChinaBuy er en købsagentplatform, der forbinder internationale købere med kinesiske sælgere. Som alle købsagenter afhænger legitimitet af aktuel servicekvalitet, brugeroplevelser og ordentlig due diligence.',
  faq_q3: 'Hvordan bruger jeg et AllChinaBuy Spreadsheet?',
  faq_a3: 'Start med at gennemse produktkategorierne, der matcher det, du leder efter. Research sælgeren, tjek for tilgængelige QC-fotos, gennemgå forsendelsesomkostninger, og følg vores trin-for-trin købsguides.',
  faq_q4: 'Hvilke forsendelsesmuligheder tilbyder AllChinaBuy?',
  faq_a4: 'AllChinaBuy tilbyder typisk flere forsendelseslinjer inklusiv EMS, DHL, FedEx og forskellige posttjenester. Forsendelsesomkostninger varierer efter destination, vægt og valgt metode.',
  faq_q5: 'Findes der AllChinaBuy kuponer eller rabatkoder?',
  faq_a5: 'Kupontilgængelighed ændrer sig over tid. Nogle platforme tilbyder sæsonbestemte kampagner, henvisningsrabatter eller førstegangsbrugerbesparelser.',
  faq_q6: 'Hvordan tjekker jeg QC-fotos på AllChinaBuy?',
  faq_a6: 'Kvalitetskontrolfotos er normalt tilgængelige i dit ordre-dashboard efter varerne er ankommet til lageret. Anmod om detaljerede QC-fotos før forsendelse.',
  faq_q7: 'Hvad er AllChinaBuy lagerprocessen?',
  faq_a7: 'Efter købet sender sælgere varer til AllChinaBuy-lageret. Varer inspiceres, fotograferes (QC) og opbevares. Du kan derefter gennemse, konsolidere og sende din pakke til din destinationsadresse.',
  faq_q8: 'Hvordan sammenligner jeg AllChinaBuy med andre købsagenter?',
  faq_a8: 'Sammenlign baseret på forsendelsespriser, servicegebyrer, QC-fotokvalitet, kundeserviceresponsivitet og brugeranmeldelser. Vores sammenligningssektion giver en struktureret måde at evaluere disse faktorer på.',

  final_cta_title: 'Klar til at Udforske AllChinaBuy Spreadsheet?',
  final_cta_desc: 'Gennemse organiserede ressourcer, produktguides og nyttige købsinformationer på ét sted.',
  final_cta_primary: 'Udforsk AllChinaBuy Spreadsheet',
  final_cta_secondary: 'Se Alle Kategorier',

  ext_btn_main: 'AllChinaBuy Spreadsheet',
  ext_btn_buy: 'Køb Det Nu',

  footer_disclaimer: 'Dette website tilbyder uafhængigt informativt indhold og garanterer ikke produktkvalitet, sælgeradfærd, forsendelsesresultater, refunderinger eller platformydelse. Brugere bør verificere aktuelle oplysninger før køb.',
  footer_about: 'Om Os',
  footer_policy: 'Redaktionel Politik',
  footer_contact: 'Kontakt',
  footer_privacy: 'Privatlivspolitik',
  footer_terms: 'Brugsvilkår',
  footer_copyright: 'AllChinaBuy Spreadsheet. Uafhængig informationsressource.',

  article_breadcrumb_home: 'Forside',
  article_breadcrumb_article: 'Artikel',
  article_read_time: 'min. læsning',
  article_updated: 'Opdateret',
  article_related: 'Relaterede Ressourcer',
  article_back_home: 'Tilbage til Forsiden',
  article_author: 'Forskningsteam',
  article_share: 'Del denne guide',
  article_toc: 'Indholdsfortegnelse',
  article_intro: 'Introduktion',
  article_conclusion: 'Konklusion',
  article_cta_text: 'Udforsk flere AllChinaBuy-ressourcer og find de bedste produkter til dine behov.',
  article_cta_button: 'Gennemse Alle Ressourcer',
};